import {useMemo} from 'react';
import assert from 'assert-ts';
import {Concept} from 'types';
import type {LinkedValueSearchPageConfig} from 'sceneExtensions/extensions/linkedValueSearch/types';
import {FieldExtensionEnum} from 'sceneExtensions/types';
import {useGetAgentQuery} from 'services/agent';

export const useLinkedValueSearchPageConfig = (
  agentId: string | undefined,
): LinkedValueSearchPageConfig | undefined => {
  // Same query as useAgent, so served from cache once the agent is loaded
  const {data: agent} = useGetAgentQuery({id: agentId!}, {skip: !agentId});
  const agentType = agent?.agentType;

  return useMemo(
    () =>
      agentId
        ? {
            type: FieldExtensionEnum.linkedValueSearch,
            sourceField: {
              fieldId: 'agentPage',
              fieldConfig: {
                entity: Concept.agent,
                entitySubtypes: agentType ? [agentType] : undefined,
                sourceEntityId: agentId,
              },
            },
            setSourceValue: (_target, action) => {
              assert(
                false,
                'useLinkedValueSearchPageConfig: Unexpected action',
                {
                  action,
                },
              );
            },
          }
        : undefined,
    [agentId, agentType],
  );
};
